export default __webpack_public_path__ + "static/media/appMode.c0ac90f9.png";